customElements.get("quick-shop-modal") || customElements.define("quick-shop-modal", class extends HTMLElement {
  connectedCallback() {
    const e = this.querySelector('input[type="checkbox"][data-locker]');
    if (!e) return;
    const t = matchMedia("(max-width:1023px)"), n = () => {
      return n = e.checked, t.matches && document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
        detail: {
          source: "quick-shop-modal",
          transform: n ? "RESET" : ""
        }
      }));
      var n;
    };
    e.addEventListener("change", n), t.addEventListener("change", n), n(), this._cleanup = () => {
      e.removeEventListener("change", n), t.removeEventListener("change", n);
    };
  }
  disconnectedCallback() {
    this._cleanup?.();
  }
});